import React, { Component } from "react";
import { Helmet } from "react-helmet";
import ReactDOM from "react-dom";

import getAppErrors from "../../../../lib/appErrors";
import Api from "../../../../lib/componentApi";

import List from "../../../../components/Users/Payment/List";
import Submit from "./Submit";

import Loading from "../../../../components/Common/Loading";
import AppErrors from "../../../../components/Common/AppErrors";
import AppInfo from "../../../../components/Common/AppInfo";

class PaymentMethodsList extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      submitPayment: false,
      errorMessage: null,
      confirmDelete: false,
      infoSection: false,
      deletedPaymentId: "",
      loading: false
    };
  }
  handleAddNewPayment = () => {
    var body = document.body;
    body.classList.add("body-overflow");
    this.setState({ submitPayment: true });
  };
  handleCloseNewPayment = (event, paymentData) => {
    var body = document.body;
    body.classList.remove("body-overflow");
    event.preventDefault();
    const { getProfile } = this.props;
    this.setState({ submitPayment: false }, () => {
      if (paymentData) {
        getProfile({ shouldUpdate: false });
      }
    });
  };
  onClickClose = section => {
    var body = document.body;
    body.classList.remove("body-overflow");
    if (section === "infoSection") {
      this.setState({
        infoSection: false,
        deletedAddressId: "",
        confirmDelete: false
      });
    }
    if (section === "errorMessage") {
      this.setState({
        errorMessage: null
      });
    }
  };
  handleDeleteCard = paymentUid => {
    event.preventDefault();
    const { confirmDelete } = this.state;
    if (confirmDelete) {
      this.setState({ loading: true });
      const { deletedPaymentId } = this.state;
      const creditCardUid = deletedPaymentId;
      Api.post(`/api/payment/delete`, { creditCardUid }, (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          const errorMessage = getAppErrors(response.code);
          this.setState({
            errorMessage: (errorMessage && errorMessage.message) || response.message,
            loading: false
          });
        } else {
          if (response.status) {
            var body = document.body;
            body.classList.remove("body-overflow");
            const { getProfile } = this.props;
            this.setState(
              {
                confirmDelete: false,
                infoSection: false,
                loading: false
              },
              () => {
                getProfile({ shouldUpdate: false });
              }
            );
          }
        }
      });
    } else {
      var body = document.body;
      body.classList.add("body-overflow");
      this.setState({
        confirmDelete: true,
        infoSection: true,
        deletedPaymentId: paymentUid
      });
    }
  };
  setDefaultPayment = paymentUid => {
    const creditCardUid = paymentUid;
    Api.post("/api/payment/default", { creditCardUid }, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        const errorMessage = getAppErrors(response.code);
        var body = document.body;
        body.classList.add("body-overflow");
        this.setState({
          errorMessage: (errorMessage && errorMessage.message) || response.message,
          loading: false
        });
      } else {
        const { getProfile } = this.props;
        getProfile({ shouldUpdate: false });
      }
    });
  };

  render() {
    const { onCloseSection, userData } = this.props;
    const { submitPayment, errorMessage, loading, infoSection } = this.state;
    const infoMessage = "Are you sure you want to delete this card?";
    const buttonText = "Confirm";
    const title = "Remove Credit Card";
    return (
      <div>
        <Helmet>
          <title>Payments</title>
          <meta property="og:title" content="Payments" />
        </Helmet>
        <div className="profile-desktop">
          {/* Header */}
          <div className="head-general with-back">
            <a
              href="javascript: void(0)"
              onClick={() => onCloseSection("paymentSection")}
              className="back"
            >
              <img src="/png/chevron-left.png" />
            </a>
            <h4>Payment Info</h4>
            <a
              href="javascript: void(0)"
              onClick={() => onCloseSection("paymentSection")}
              className="close"
            >
              <i className="icon icon-close" />
            </a>
          </div>
          {/* Header */}
          <h4 className="hide-xs general-title">Payment Methods</h4>

          <div className="add-address visible-xs">
            <a onClick={this.handleAddNewPayment} href="javascript: void(0)">
              <i className="icon icon-close icon-plus" /> Add payment method
            </a>
          </div>
          {(infoSection &&
            ReactDOM.createPortal(
              <AppInfo
                message={infoMessage}
                title={title}
                onClickClose={() => this.onClickClose("infoSection")}
                buttonText={buttonText}
                onSubmit={() => this.handleDeleteCard()}
              />,
              document.body
            )) || <noscript />}
          {(errorMessage &&
            ReactDOM.createPortal(
              <AppErrors
                message={errorMessage}
                onClickClose={() => this.onClickClose("errorMessage")}
              />,
              document.body
            )) || <noscript />}
          {(loading && <Loading />) || <noscript />}
          {(submitPayment &&
            ReactDOM.createPortal(
              <Submit handleCloseSection={this.handleCloseNewPayment} />,
              document.body
            )) || <noscript />}
          <List
            payments={userData.creditCards}
            handleDeleteCard={this.handleDeleteCard}
            setDefaultPayment={this.setDefaultPayment}
          />
        </div>
        {/* .profile-desktop */}

        <div className="hide-xs">
          <div className="use-buttons mt-10px">
            <a
              onClick={this.handleAddNewPayment}
              href="javascript: void(0)"
              className="btn btn-blue"
            >
              + Add a new payment method
            </a>
          </div>
          {/* .use-buttons */}
        </div>
        {/* .hide-xs */}
      </div>
    );
  }
}

export default PaymentMethodsList;
